import { render } from "./messages.vue?vue&type=template&id=14a57972&ts=true"
import script from "./messages.vue?vue&type=script&lang=ts"
export * from "./messages.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__